import { FormLayout, MultiSelectStoreDropdown } from 'components/common'
import { UseFormSetValue, FieldValues, FieldErrors } from 'react-hook-form'
import { configurationsFields } from './utils'

const { DARK_STORES } = configurationsFields

type Props = {
  setValue: UseFormSetValue<FieldValues>
  darkStores?: string[]
  errors?: FieldErrors<FieldValues>
}

/**
 * Dark stores served by the dedicated Aggregator API cron. Selecting them here
 * is what drives that cron — it pushes pricing for exactly these stores to
 * Instashop on its own schedule.
 *
 * The list is deliberately NOT filtered to active stores: the dropdown writes
 * back only the codes it has options for, so hiding a store here would silently
 * drop it from the saved configuration.
 */
const DarkStoresSection = ({ setValue, darkStores, errors }: Props) => {
  return (
    <>
      <h3 className="title">Dark Store Configuration</h3>
      <FormLayout>
        <div className="grid gap-x-10 gap-y-3 mid-md:grid-cols-3">
          <MultiSelectStoreDropdown
            label={DARK_STORES.label}
            name={DARK_STORES.key}
            setValue={setValue}
            error={(errors as Record<string, any>)?.[DARK_STORES.key]?.message}
            defaultSelected={darkStores as []}
            resetForm={false}
            hintText="Stores pushed to Instashop by the Dark Store Aggregator API cron. Selecting none turns that cron off."
          />
        </div>
      </FormLayout>
    </>
  )
}

export default DarkStoresSection
